import React from "react";
import Menu from "../menu";
import LatestNews from '../../components/latestNews';

class Home extends React.Component {

    constructor(props) {
        console.log('test jlk');
        props = {
            screenName: 'Home'
            , ...props
        };
        console.log(props);
        super(props);
        this.state = {
            loading: false,
        };
    }


    render() {
        return (
            <div>
                <Menu selectedTab={'/'} />
                <p>Home</p>

                <LatestNews />
            </div>
        );
    }


}

export default Home;


// WEBPACK FOOTER //
// ./src/screens/home/index.js